'use client';
import { useEffect, useRef, useState } from 'react';
import { useInstantSearch, usePagination } from 'react-instantsearch';

export function useCustomInfiniteScroll() {
	const [allHits, setAllHits] = useState<any[]>([]);
	const [lastSearchState, setLastSearchState] = useState<string>('');
	const [isLoading, setIsLoading] = useState(false);
	const { currentRefinement, nbPages, refine, canRefine } = usePagination();
	const { results } = useInstantSearch();
	const sentinelRef = useRef(null);

	const hasMore = canRefine && currentRefinement < nbPages - 1;

	// Reset when filters/query change or on first page
	useEffect(() => {
		const currentSearchState = JSON.stringify({
			query: results?.query || '',
			facets: results?.facets || {},
			disjunctiveFacets: results?.disjunctiveFacets || {},
			hierarchicalFacets: results?.hierarchicalFacets || {},
		});
		const searchStateChanged = currentSearchState !== lastSearchState;

		if (currentRefinement === 0 || searchStateChanged) {
			setAllHits(results.hits);
			setLastSearchState(currentSearchState);
			setIsLoading(false); // Reset loading state
			if (currentRefinement !== 0 && searchStateChanged) {
				refine(0);
			}
		} else {
			console.log(
				'currentRefinement',
				currentRefinement,
				results.page,
				currentRefinement * results.hitsPerPage + results.hits.length > allHits.length,
				currentRefinement * results.hitsPerPage + results.hits.length,
				allHits.length,
			);
			if (currentRefinement === results.page && results.page > 0) {
				// Only append if this is a new page load
				setAllHits(prev => [...prev, ...results.hits]);
				setIsLoading(false); // Reset loading state after successful load
			}
		}
	}, [currentRefinement, results, lastSearchState]); // Remove isLoading and allHits

	// Intersection Observer
	useEffect(() => {
		const loadMore = () => {
			if (hasMore && !isLoading) {
				setIsLoading(true);
				refine(currentRefinement + 1);
			}
		};

		const observer = new IntersectionObserver(
			entries => {
				if (entries[0].isIntersecting) {
					loadMore();
				}
			},
			{ threshold: 0.1 },
		);

		if (sentinelRef.current) observer.observe(sentinelRef.current);
		return () => observer.disconnect();
	}, [hasMore, currentRefinement, isLoading]);

	return {
		hits: allHits,
		isLoading,
		hasMore,
		sentinelRef, // Return the ref
		refine,
		canRefine,
		currentRefinement,
		nbPages,
	};
}
